import React from 'react';
import { ToastOptions, toast as reactHotToast } from 'react-hot-toast';
import Icon from '../icon';
import { BodySmallRegular, H4 } from '../typography';

type CustomToastType = {
  variant: 'success' | 'info' | 'error';
  title?: string;
  subTitle?: string;
  customComponent?: React.ReactNode;
};

export const triggerToast = (
  { title, subTitle, variant, customComponent }: CustomToastType,
  options?: ToastOptions
) => {
  const isInfoIcon = variant === 'info';
  const isError = variant === 'error';
  const defaultDuration = isError ? 8000 : isInfoIcon ? 3000 : 3000;

  const textColor =
    variant === 'success'
      ? 'text-success-800'
      : isInfoIcon
      ? 'text-primary-800'
      : 'text-danger-800';
  const backgroundColor =
    variant === 'success'
      ? 'bg-success-100'
      : isInfoIcon
      ? 'bg-primary-100'
      : 'bg-danger-100';

  const containerClass = `flex justify-between items-center ${backgroundColor} p-4 rounded shadow-md w-full`;

  return reactHotToast?.[isInfoIcon ? 'loading' : variant](
    (t) => (
      <div
        data-cy={`${variant}-toast`}
        className={containerClass}
        style={{ maxWidth: isError ? '450px' : undefined }}
      >
        {customComponent ? (
          customComponent
        ) : (
          <>
            <div className="flex items-center">
              <div className="mr-3 flex-shrink-0">
                {variant === 'success' ? (
                  <Icon name="Check" className="text-success-800 w-5 h-5" />
                ) : isInfoIcon ? (
                  <Icon
                    name="InfoFilled"
                    className="text-primary-800 w-5 h-5"
                  />
                ) : (
                  <Icon name="Warning" className="text-danger-800 w-5 h-5" />
                )}
              </div>
              <div className="flex-1">
                <H4 textColor={textColor}>{title}</H4>
                {subTitle && (
                  <BodySmallRegular textColor={textColor}>
                    {subTitle}
                  </BodySmallRegular>
                )}
              </div>
            </div>
            <div
              onClick={() => reactHotToast.dismiss(t.id)}
              data-cy={`close-toast-button`}
              className="cursor-pointer ml-3 flex-shrink-0"
            >
              <Icon name="Close" />
            </div>
          </>
        )}
      </div>
    ),
    {
      duration: defaultDuration,
      position: 'top-right',
      ...options,
      // Setting icon to null to prevent it from rendering outside our container
      icon: null
    }
  );
};
